//import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import "rxjs/Rx";
import 'rxjs/add/operator/map';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Inject, Injectable } from '@angular/core';
//import { Inject, Injectable } from '@angular/core';
//import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
declare function readCookie(name): any;


class customerData {

}

@Injectable()
export class ApiService {
    //public postsURL = "http://dev-on-track.co.in/api/";
   // public postsURL = "http://159.65.154.92/api/";
      public postsURL = "https://api.on-track.in/api/";
    // public postsURL ="http://localhost:1337/api/"
    public customer = this.postsURL + "customer";
    public cutomerDetails = this.postsURL + "customer/";
    public joinWaitlistUrl = this.postsURL + "joinWaitlist";
    public signupURL = this.postsURL + "signup";
    public LoginURL = this.postsURL + "authenticate";
    public cookieLoginURL = this.postsURL + "authenticateCookie";
    public LogOut = this.postsURL + "weblogout";
    public getBookingBYquery = this.postsURL + "getBookingByQuery";
    public getBookingByQueryForInvoice = this.postsURL + "getBookingByQueryForInvoice";
    public ongoingBooking = this.postsURL + "getOngoingBooking";
    public referralURL = this.postsURL + "getReferalPoints";
    public validateReferralURL = this.postsURL + "validatePromoCode";
    public getCustomerPoints = this.postsURL + "getReferalPoints";
    public initiatePaymentURL = this.postsURL + "initiatePayment";
    public paymentResponseURL = this.postsURL + "paymentResponse";
    public sendOtpURL = this.postsURL + "sendOtp";
    public resendURL = this.postsURL + "resendOtp";
    public verifyOTP_URL = this.postsURL + "verifyOtp";
    public profileUpdateURL = this.postsURL + "saveProfile";
    public GET_PICKUP_LOCATION_URL = this.postsURL + "location?city=1";
    public changePasswordURL = this.postsURL + "changePassword";
    public verifyPasswordURL = this.postsURL + "verifyPasswordToken";
    public userRating = this.postsURL + "submitRating";

    public GET_SERVICE_REQUEST_TIME = this.postsURL + "getTimeSlotByDate"; //post method
    public GET_SERVICE_BY_CUSTOMER = this.postsURL + "getServiceByCustomer?id="; // get method
    public CREATE_SERVICE_REQUEST = this.postsURL + "createService"; // post method
    public EXTEND_BOOKING_API = this.postsURL + "extendBooking";// extend booking
    public GET_SUBSCRIPTION_INFO = this.postsURL + "getSubscriptionInfo"; // to get the information of subscription.
    public EXTEND_SUBSCRIPTION_MONTH = this.postsURL + "Subscription/"; // for updating the value of subscription month

    public GET_PAYMENT_INFO = this.postsURL + "getBookingInfo"; // to get the information of the payment using id
    public GET_EXTEND_PAYMENT_INFO = this.postsURL + "getBookingExtendInfo"; // to get the information of the payment using id
    public extendPaymentResponseURL = this.postsURL + "extendPaymentResponse";
    public normal_subscription_URL=this.postsURL+ "Booking/";
    public subscription_URL=this.postsURL + "Subscription";
    public checkLogin = this.postsURL + "isLoggedIn";

    //http://159.65.154.92/api/getServiceByCustomer?id=6840
    //http://159.65.154.92/api/getServiceByCustomer?id=6840
    // { date: "2018-10-27" }
    //private url1 = "http://159.65.154.92/api/customer";


    constructor(private http: HttpClient, @Inject(LOCAL_STORAGE) private storage: WebStorageService) {

    }

    

    getFromLocalData(key): string {
        let userIdData: any = [];
        return userIdData[key] = this.storage.get(key);
    }

    saveInLocalData(key, val): void {
        let data: any = [];
        this.storage.set(key, val);
        //this.data[key]= this.storage.get(key);
    }

    checkCookiesInService(){

        console.log("in checkCookiesInService......");
        let cookiesValue;
        
       // getDocumentCookies();
        cookiesValue = readCookie('user');
       

        if ((cookiesValue == null) || (cookiesValue == "")) {
          return null;
        } else {
          return cookiesValue;
        }
        
    }


    checkUserLoggedIn(): boolean {
        let userLogged = false;

        let cookiesValueInService = this.checkCookiesInService();

        if ((cookiesValueInService == null) || (cookiesValueInService == "")) {
            userLogged = false;
        } else {
            userLogged = true;
        }
        return userLogged;
    }

   

 
    //aa:{};
    data: Observable<Array<any>>;

    get(name1) {
        return this.http
            .get(this.postsURL + name1)
            .do(res => //console.dir(res)
                res
            )
            .catch(this.handleError);
    }

    // get(name1): any {
    // return this.http
    // .get(this.postsURL + name1)
    // .map((response: Response) => {
    // //console.dir(response);
    // return response;
    // })
    // .catch(this.handleError);
    // }


    getsd(id) {
        let urrr = this.postsURL + id;
        return this.http.get(urrr)
            .subscribe((data: customerData) => {
                // Data extraction from the HTTP response is already done
                // Display the result
                //console.log('TJ user data', data);
                return data;
            });

        //Note: you no l 
    }

    getData2(id) {
        let urrr = this.postsURL + id;
        return this.http.get(urrr)
            .map((res: Response) => res.json());
    }

    refresh(): void {
        window.location.reload();
    }

    private handleError(error: Response) {
        return Observable.throw(error.statusText);
    }

}




// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/api.service.ts